var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('DataBox',{attrs:{"loading":_vm.tryCheckKey}},[(_vm.isValidKey)?_c('SetPassword',{staticClass:"basic-wrapper form-wrapper"}):_c('GetEmailLink',{staticClass:"basic-wrapper form-wrapper"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }